<template>
  <div v-if="policyPrepare" >
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        Política de registro horario
      </h2>
    </div>
    <b-card>
        <div v-html="content" >
        </div>
        <div v-if="files.length" >
          <h4 class="mb-1">Archivo</h4>
          <div v-for="file in files" :key="file.name" class="mb-1">
            <span class="d-inline-block">
              <private-file-download
                :file-url="file.path"
                :file-name="file.name"
              />
            </span>
          </div>
        </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import PrivateFileDownload from '@/components/ui/PrivateFileDownload.vue'

export default {
  components: {
    BButton,
    BCard,
    PrivateFileDownload,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      policyPrepare: false,
      content: '',
      files: [],
      profileFile: null,
    }
  },
  computed: {
    ...mapGetters({
      policy: 'config/getPolicy',
      currentClient: 'clients/getCurrentClient'
    }),
  },
  methods: {
    ...mapActions({
      getPolicy: 'config/getPolicy'
    }),
    setData() {
      if (this.policy.files_policy !== undefined && this.policy.files_policy !== null && this.policy.files_policy) {
        const files = []
        this.policy.files_policy.forEach(element => {
          const file = {
            name: element.name,
            path: element.path,
            urlDelete: '',
          }
          files.push(file)
        })
        this.files = files
      }
      this.content = this.policy.content_policy
      this.policyPrepare = true
    },
  },
  async created() {
    await this.getPolicy(this.currentClient.id)
    await this.setData()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
